'use client';

import { BriefcaseIcon, MapPinIcon } from '@heroicons/react/16/solid';
import React, { useContext } from 'react';
import { JobContent } from '@gate-js/react';
import classNames from 'classnames';
import { GateStyleContext } from './GateStyleContext';
import { resolveSetting } from '../../utils/settingsHelper';
import PublicProfile from './PublicProfile';
import ApplyButton from './ApplyButton';
import SalaryDetail from './SalaryDetail';

export default function RenderDetail({ job, children, showButton = true }) {
	const { settings, active, text, twoButtons, iconColor, showProfile, iconBefore, dark, documents, ...button } = useContext(GateStyleContext);

	const renderButton = () => (
		<ApplyButton
			active={active}
			{...button}
			settings={settings}
			text={text}
			jobLanguage={job.language}
			iconBefore={iconBefore}
			documents={documents}
			options={active ? { jobId: job.id } : null}
		/>
	);

	return (
		<div className={classNames('space-y-4 prose max-w-2xl prose-headings:mt-4 prose-headings:mb-2 prose-ul:mb-0 prose-p:my-0', { 'prose-invert': dark })}>
			<div className="@sm:flex items-baseline gap-4 space-y-2 @sm:space-y-0 @sm:justify-between">
				<div className="min-w-0 flex-1">
					<h1
						className="text-2xl font-bold leading-7 @sm:text-3xl @sm:tracking-tight"
					>
						{job.title}
					</h1>
					<div className="mt-1 flex flex-col @sm:mt-0 @sm:flex-row @sm:flex-wrap">
						{job?.employmentForms?.length > 0 && (
							<div className="mt-2 flex items-center text-sm @sm:mr-6">
								<BriefcaseIcon
									style={{ color: resolveSetting(iconColor, settings) }}
									aria-hidden="true"
									className="mr-1.5 h-5 w-5 flex-shrink-0"
								/>
								{job.employmentForms.map((i) => (i.locale ? i.locale[job.language] : i.name)).filter((i) => i).join(', ')}
							</div>
						)}
						{job.location && (
							<div className="mt-2 flex items-center text-sm @sm:mr-6">
								<MapPinIcon
									style={{ color: resolveSetting(iconColor, settings) }}
									aria-hidden="true"
									className="mr-1.5 h-5 w-5 flex-shrink-0"
								/>
								{job.location}
							</div>
						)}
						<SalaryDetail info={job.salaryInfo} salary={job.salary} jobTitle={job.title} color={resolveSetting(iconColor, settings)} />
					</div>
				</div>
				{twoButtons && renderButton()}
			</div>
			{job.file && (
				<img src={job.file.url} alt={job.file.name} className="w-full h-auto rounded-2xl" />
			)}
			<div>
				<JobContent>{job.content}</JobContent>
			</div>
			{showButton && renderButton()}
			{children}
			{job.contactPerson && showProfile && (
				<PublicProfile user={job.contactPerson} />
			)}
		</div>
	);
}
